import {
  Account_Read_Typeahead,
  AccountType,
  getV1CompaniesAccountsTypeahead,
  GetV1CompaniesAccountsTypeaheadData,
} from '@treadinc/horizon-api-spec';
import { FieldValues } from 'react-hook-form';

import { AccountTypeahead } from '~hooks/useAccount/models';

import AsyncAutocompleteField from '../v2/Autocomplete/AsyncAutocompleteField';
import { CommonAsyncAutocompleteFieldProps } from '../v2/Autocomplete/types';

type Props<T extends FieldValues> = CommonAsyncAutocompleteFieldProps<
  T,
  Account_Read_Typeahead,
  AccountTypeahead,
  GetV1CompaniesAccountsTypeaheadData
> & {
  companyId: string;
  accountTypes?: AccountType[];
};

export default function AutocompleteAccountsTypeahead<T extends FieldValues>({
  accountTypes,
  companyId,
  isDisabled,
  ...rest
}: Props<T>) {
  return (
    <AsyncAutocompleteField
      {...rest}
      isDisabled={companyId ? isDisabled : true}
      queryName="AutocompleteAccountsTypeahead"
      fetchFn={{
        arguments: {
          path: { 'company-id': companyId },
          query: {
            ...(accountTypes &&
              accountTypes.length > 0 && {
                'filter[account_types][]': accountTypes,
              }),
          },
        },
        request: getV1CompaniesAccountsTypeahead,
      }}
      parseFn={(item: Account_Read_Typeahead) => {
        const parsed = AccountTypeahead.parse(item);

        return { _entity: parsed, label: parsed.name, value: parsed.id };
      }}
    />
  );
}
